module.exports = __webpack_public_path__ + "img/full5-min.a46a4ee0.png";